// extracted by mini-css-extract-plugin
export default {"container":"EstimateTemplate_container__V9R0V","body":"EstimateTemplate_body__yT95K"};